import styled from 'styled-components';

import { btn, btnLink, danger } from '../base';

interface buttonColor {
  buttonColor?: string;
  buttonFont?: string;
}

export const dangerButton = styled.button`
  ${btn(danger)}
`;

export const dangerButtonLink = styled.div`
  ${btnLink(danger)}
`;

export const text = styled.span<buttonColor>`
  font-style: normal;
  color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'var(--danger)')};
  font-size: ${({ buttonFont }) => (buttonFont ? buttonFont : 'var(--fs-body)')};
`;
